// BuyTab.js
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  FilterControls,
  SummaryCard,
  OrderTable,
  WarehouseSummary,
  WarehouseTables,
  getMaterialTypes,
  getFilteredOrders,
  calculateTotals,
  separateByPlace,
} from '../../Component/SharedComponents';

const BuyTab = ({ orders, date, setDate, onViewDetail, allData }) => {
  const [materialFilter, setMaterialFilter] = useState('all');

  const materialTypes = getMaterialTypes(orders);
  const filteredOrders = getFilteredOrders(orders, materialFilter);

  const totals = calculateTotals(filteredOrders);

  const { oldWarehouse, newWarehouse, otherWarehouse } =
    separateByPlace(filteredOrders);

  return (
    <>
      <FilterControls
        materialTypes={materialTypes}
        currentFilter={materialFilter}
        filteredOrders={filteredOrders}
        setFilter={setMaterialFilter}
        date={date}
        setDate={setDate}
      />

      <WarehouseSummary
        oldWarehouseOrders={oldWarehouse}
        newWarehouseOrders={newWarehouse}
        filteredOrders={filteredOrders}
        otherWarehouseOrders={otherWarehouse}
        type="BUY"
      />

      <WarehouseTables
        oldWarehouseOrders={oldWarehouse}
        newWarehouseOrders={newWarehouse}
        otherWarehouseOrders={otherWarehouse}
        materialFilter={materialFilter}
        allData={allData}
        onViewDetail={onViewDetail}
      />
    </>
  );
};

BuyTab.propTypes = {
  orders: PropTypes.array,
  date: PropTypes.string.isRequired,
  setDate: PropTypes.func.isRequired,
  onViewDetail: PropTypes.func.isRequired,
};

BuyTab.defaultProps = {
  orders: [],
};

export default BuyTab;
